module.exports = __webpack_public_path__ + "img/修改状态.29c46c65.svg";